<div class="header">
  <div class="left">
    <div class="burger-container" data-cy="desktop-menu-btn" (click)="toggleMenu()">
      <div class="menu-item-container" [class.active]="isMenuRoute" id="walkThroughStep8Desktop">
        <img src="assets/imgs/header/burger.svg" alt="" class="icon-default" />
        <img src="assets/imgs/header/burger-active.svg" alt="" class="icon-active" />
      </div>
    </div>

    <div class="links">
      <div class="menu-item-container" (click)="goTo('home')" [class.active]="currentRoute === '/home'" id="walkThroughStep4Desktop">
        <img src="assets/imgs/header/read.svg" alt="" class="icon-default" />
        <img src="assets/imgs/header/read-active.svg" alt="" class="icon-active" />
        <div class="menu-item">{{ 'PWA_web_header_2_read' | translate }}</div>
      </div>

      <div data-cy="header-explore-link" class="menu-item-container" (click)="goTo('explore')" [class.active]="isExploreRoute" id="walkThroughStep5Desktop">
        <img src="assets/imgs/header/explore.svg" alt="" class="icon-default" />
        <img src="assets/imgs/header/explore-active.svg" alt="" class="icon-active" />
        <div class="menu-item">{{ 'PWA_web_header_3_explore' | translate }}</div>
      </div>

      <div data-cy="header-saved-link" class="menu-item-container" (click)="goTo('saved')" [class.active]="isSavedRoute" id="walkThroughStep6Desktop">
        <img src="assets/imgs/header/saved.svg" alt="" class="icon-default" />
        <img src="assets/imgs/header/saved-active.svg" alt="" class="icon-active" />
        <div class="menu-item">{{ 'PWA_web_header_4_saved' | translate }}</div>
      </div>

      <div data-cy="header-dashboard-link" class="menu-item-container" (click)="goTo('dashboard')" [class.active]="currentRoute === '/dashboard'" id="walkThroughStep7Desktop">
        <img src="assets/imgs/header/progress.svg" alt="" class="icon-default" />
        <img src="assets/imgs/header/progress-active.svg" alt="" class="icon-active" />
        <div class="menu-item">{{ 'PWA_web_header_5_progress' | translate }}</div>
      </div>
    </div>
  </div>

  <div class="right">
    <img class="worldreader" src="assets/imgs/header/worldreader.svg" alt="" (click)="navigationService.navigateRoot('home')" />
    @if ((userState.isGuest$ | async) && ((flagsState.flags$ | async)?.walkthroughCompletedOrDismissed)) {
      <div class="menu-item-container" (click)="goTo('authentication')"  data-cy="sign-in-container" >
        <img src="assets/imgs/header/person.svg" alt="" class="icon-default" />
        <img src="assets/imgs/header/person-active.svg" alt="" class="icon-active" />
        <div class="menu-item" >{{ 'PWA_homeLibrary_header_guest_signIn' | translate }}</div>
      </div>
    } @else {
      <img
        data-cy="header-sprouty-icon"
        (click)="startHomeTour()"
        id="walkThroughAlwaysHighlight"
        src="assets/imgs/header/sprouty/{{ (productTourService.currentStep$ | async)?.sproutyIcon || 'default.svg' }}"
        alt=""
        class="buddy"
        [class.tour-highlight]="productTourService.productTourRunning$ | async"
      />
    }
  </div>
</div>

